import { render, staticRenderFns } from "./DeliveryZoneView.vue?vue&type=template&id=54f14404&scoped=true"
import script from "./DeliveryZoneView.vue?vue&type=script&lang=js"
export * from "./DeliveryZoneView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f14404",
  null
  
)

export default component.exports